"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisStatus = void 0;
var AnalysisStatus;
(function (AnalysisStatus) {
    AnalysisStatus["processing"] = "processing";
    AnalysisStatus["completed"] = "completed";
    AnalysisStatus["failed"] = "failed";
})(AnalysisStatus = exports.AnalysisStatus || (exports.AnalysisStatus = {}));
//# sourceMappingURL=CompanyAnalysis.js.map